import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { preserveInstitutionParams } from '../utils/navigation';
import React, { ReactNode } from 'react';

interface PrivateRouteProps {
  children?: ReactNode;
}

export default function PrivateRoute({ children }: PrivateRouteProps) {
  const { currentUser } = useAuth();

  // If we have a custom child element passed in, use that
  if (children) {
    return currentUser ? <>{children}</> : <Navigate to={preserveInstitutionParams("/login")} />;
  }

  // Otherwise use the outlet for nested routes
  return currentUser ? <Outlet /> : <Navigate to={preserveInstitutionParams("/login")} />;
} 